import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import BusinessPlanScreen from "./BusinessPlanScreen";
import { BusinessPlanUsersUI } from "./ui/BusinessPlanUsersUI";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "BusinessMembers"
>;

export const BusinessPlanMembersScreen = observer((props: Props) => {
  return (
    <BusinessPlanScreen {...props}>
      <BusinessPlanUsersUI businessPlanUid={props.route.params.businessUid} />
    </BusinessPlanScreen>
  );
});

export default BusinessPlanMembersScreen;
